import { useCallback, useEffect, useState } from 'react';
import { Matcher } from 'react-day-picker';

interface UseDatetimePickerOptions {
  closeOnScroll?: boolean;
}

export const useDatetimePicker = ({
  closeOnScroll,
}: UseDatetimePickerOptions = {}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = useCallback((e: Event) => {
    const target = e.target as HTMLElement | null;
    if (target?.closest('[role="listbox"]')) return;

    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!closeOnScroll || !isOpen) return;

    const listener = (e: Event) => handleScroll(e);
    window.addEventListener('scroll', listener, true);

    return () => window.removeEventListener('scroll', listener, true);
  }, [closeOnScroll, isOpen, handleScroll]);

  const resolveDisabledProps = useCallback(
    (disabled?: Matcher | Matcher[] | boolean) => ({
      isButtonDisabled: typeof disabled === 'boolean' ? disabled : false,
      calendarDisabled:
        typeof disabled === 'boolean'
          ? disabled
            ? true
            : undefined
          : disabled,
    }),
    []
  );

  return { isOpen, setIsOpen, resolveDisabledProps };
};
